// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"bef38e4d","455":"3b550125","585":"a45e13b9","977":"7f6bebf2"}[chunkId] + ".chunk.js";
};